import { inject, observer } from 'mobx-react';
import { withRouter } from 'react-router';
import React, { Component, Fragment } from 'react';
import { Link } from 'react-router-dom';

import './style.scss';


@inject('NavigationStore')
@observer
class Navigation extends Component {
  state = { menu: [] }
  UNSAFE_componentWillMount() {
    const { name, NavigationStore: { populate } } = this.props;
    populate(name);
  }

  componentDidMount() {
    const { NavigationStore: { enableTouch } } = this.props;
    enableTouch();
  }

  renderNavItem = (item, router) => {
    const { NavigationStore: { isTouch, toggleNav, }, toggleTheNav } = this.props;

    console.log("item")
    console.log(item)
    return (
      <li key={item.id} className={item.children ? 'has-sub-nav' : ''}>
        {/* <a href='' onClick={(e) => this.navigate(e, item)} target={blank} className={isActive(item, router.params.slug)}>
          {item.title}
        </a> */}

        <div className='has-sub-nav-top'>
          <Link to={`/${item.url}`} onClick={toggleTheNav}>
            {item.title}
          </Link>
          {item.children ?
            <div className="arrow-box">
              <span className="drop-down-arrow">▾</span>
            </div>
            : ''
          }
        </div>
        {item.children &&
          <Fragment>
            {isTouch && <button data-active={false} onClick={toggleNav}><span>&darr;</span></button>}
            <ul className="sub-nav" data-active={false}>
              {item.children.map(child => this.renderNavItem(child, router))}
            </ul>
          </Fragment>
        }
      </li>
    )
  }

  render() {
    const { match, active, name, NavigationStore: { menu } } = this.props;
    if (!menu[name]) {
      return <Fragment />
    }

    return (
      <nav className={name} data-active={active}>
        <ul className="top-nav">
          {
            menu[name].map(
              item => this.renderNavItem(item, match)
            )
          }
        </ul>
      </nav>
    )

  }
}

export default withRouter(Navigation)
